import { render, staticRenderFns } from "./kngItem.vue?vue&type=template&id=7b0c5983&scoped=true"
import script from "./kngItem.vue?vue&type=script&lang=js"
export * from "./kngItem.vue?vue&type=script&lang=js"
import style0 from "./kngItem.vue?vue&type=style&index=0&id=7b0c5983&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c5983",
  null
  
)

export default component.exports